@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-row items-center ml-4 grid grid-cols-6 gap-4">
      @if (field.minRows === 0) {
        <div class="leading-6 font-large text-lg col-start-1 col-span-2">{{ field.label | localize }}</div>
      }
      @if (field.minRows > 0) {
        <div class="leading-6 font-large text-lg col-start-1 col-span-2">{{ field.label | localize }}*</div>
      }
      <div class="col-start-6 col-span-1">
        @if (!editView) {
          <button [disabled]="field.control.status === 'DISABLED'" mat-flat-button class="ml-300 mr-2 mb-3" color="primary"
            (click)="editView = !editView">
            <span>{{ "editView" | transloco }}</span>
          </button>
        }
        @if (editView) {
          <button mat-flat-button class="ml-300 mr-2 mb-3" color="primary"
            (click)="createTableView()">
            <span>{{ "viewDataTable" | transloco }}</span>
          </button>
        }
      </div>
    </div>
  }
  @if (editView) {
    <div class="flex flex-col justify-between mb-2 mt-4 px-2">
      <div [ngClass]="{'error-panel': field.control.hasError('incorrect')}" class="flex flex-col flex-auto mb-2 px-2">
        <mat-accordion class="w-full">
          @for (embeddedForm of field.embeddedForms; track embeddedForm; let i = $index) {
            <div class="flex flex-row w-full">
              <mat-expansion-panel class="mb-1 w-full" [ngClass]="{'error-panel': controlHasErrors(embeddedForm)}" [expanded]="panel === i" (opened)="setPanel(i)"
                (closed)="closePanel(i)" hideToggle="true">
                <mat-expansion-panel-header class="w-full">
                  <mat-panel-title class="flex flex-row justify-between">
                    <div class="flex flex-col w-full mx-2">
                      <span class="font-bold font-large text-lg mr-4">
                        {{ chooseOption(embeddedForm) }}
                      </span>
                    </div>
                    <div class="flex flex-col justify-end">
                      @if (panel === i && (panels && panels['_results'].length !== 0 && this.panels['_results'][i]?._expanded)) {
                        <mat-icon
                          >
                        remove</mat-icon>
                      }
                      @if (panel !== i || (panels && panel === panels['_results'].length - 1 && panel > 0 && panel !== i)) {
                        <mat-icon
                          >
                        add</mat-icon>
                      }
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <dtype-component-list class="w-full" [dtypeForm]="embeddedForm" [isUpdate]="isUpdate">
                </dtype-component-list>
                <div class="flex flex-row justify-end w-full">
                  <!-- <button *ngIf="(field.maxRows && field.maxRows > field.embeddedForms?.length) || !field.maxRows" mat-flat-button class="mt-2 mr-3" color="accent" (click)="addItem()"
                  [disabled]="field.readonly || field.control.disabled">
                  <mat-icon class="icon-size-5 mr-2" svgIcon="mat_outline:add"></mat-icon>
                  {{ "addRow" | transloco }}
                </button> -->
                <button mat-flat-button class="mt-2 mr-3" color="primary"
                  (click)="saveItem(embeddedForm, i)"
                  [disabled]="field.readonly || field.control.disabled">
                  {{ "saveRow" | transloco }}
                </button>
                @if (panels && panels['_results'].length > 1 || !required) {
                  <button mat-flat-button
                    class="mt-2 mr-1" color="warn" (click)="removeItem(i)"
                    [disabled]="field.readonly || field.control.disabled">
                    {{ "removeRow" | transloco }}
                  </button>
                }
              </div>
            </mat-expansion-panel>
          </div>
        }
        <!-- <div>
        <button *ngIf="(field.maxRows && field.maxRows > field.embeddedForms?.length) || !field.maxRows" mat-flat-button class="m-3" color="accent" (click)="addItem()"
          [disabled]="field.readonly || field.control.disabled">
          <mat-icon class="icon-size-5 mr-2" svgIcon="mat_outline:add"></mat-icon>
          {{ "addRow" | transloco }}
        </button>
      </div> -->
    </mat-accordion>
    @if (field.hint) {
      <div class="text-md text-secondary">{{ field.hint | localize }}</div>
    }
  </div>
</div>
}
@if (!editView) {
  <div [ngClass]="{'error-panel': someRowHasError() || field.control.hasError('incorrect')}" class="flex flex-col justify-between mb-2 mt-4 border">
    <!-- Header -->
        <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] z-10 text-sm sticky top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
                    bg-gray-50 dark:bg-slate-900">
      @for (tag of tableHeader; track tag) {
        <div class="flex items-center">
          {{ tag | localize }}
        </div>
      }
    </div>
    <!-- Rows -->
    @for (row of tableData; track row; let i = $index) {
      <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] items-center gap-4 py-3 px-4 sm:px-6 border-b">
        @for (value of row; track value) {
          <div class="flex items-center">
            {{ transformRowValue(value) }}
          </div>
        }
      </div>
    }
  </div>
}
@if (required && (defaultRow || field.embeddedForms.length === 0)) {
  <div class="text-md text-warn leading-none font-medium">
    {{ 'errorRequiredField' | transloco }}
  </div>
}
@if (someRowHasError()) {
  <div [ngClass]="{'ml-4': editView}" class="text-md text-warn leading-none font-medium">
    {{ 'errorRowsInvalid' | transloco }}
  </div>
}
@if (field.control.hasError('incorrect')) {
  <div [ngClass]="{'ml-4': editView}" class="text-md text-warn leading-none font-medium">
    {{ 'errorMinRowsInvalid' | transloco }} {{field.minRows}}
  </div>
}
}